import { render } from "./RegisterStores.vue?vue&type=template&id=d325f030"
import script from "./RegisterStores.vue?vue&type=script&lang=js"
export * from "./RegisterStores.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__